import React from 'react';
import { Badge, Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

interface DocumentStatusTagProps {
  status?: API.DocumentStatusCode;
  style?: React.CSSProperties;
  dot?: boolean;
}

const DocumentStatusTag: React.FC<DocumentStatusTagProps> = ({ status, style, dot = false }) => {
  const { t } = useTranslation();

  if (!status) {
    return null;
  }

  // 获取状态标签颜色
  const getStatusColor = (status: API.DocumentStatusCode) => {
    switch (status) {
      case 'PUBLISHED':
        return 'green';
      case 'CONTROLLED':
        return 'cyan';
      case 'APPROVED':
        return 'orange';
      case 'REVIEW_PASSED':
      case 'AUDIT_PASSED':
      case 'REVIEW':
        return 'blue';
      case 'DRAFT':
      case 'DRAFT_LOCKED':
        return 'default';
      case 'OBSOLETE':
        return 'red';
      default:
        return 'default';
    }
  };

  // 获取状态文本
  const getStatusText = (status: API.DocumentStatusCode) => {
    switch (status) {
      case 'PUBLISHED':
        return t('pages.docEditor.header.published');
      case 'CONTROLLED':
        return t('pages.docEditor.header.controlled');
      case 'APPROVED':
        return t('pages.docEditor.header.approved');
      case 'REVIEW_PASSED':
        return t('pages.docEditor.header.reviewPassed');
      case 'AUDIT_PASSED':
        return t('pages.docEditor.header.auditPassed');
      case 'REVIEW':
        return t('pages.docEditor.header.review');
      case 'DRAFT':
        return t('pages.docEditor.header.draft');
      case 'DRAFT_LOCKED':
        return t('pages.docEditor.header.draftLocked');
      case 'OBSOLETE':
        return t('pages.docEditor.header.obsolete');
      default:
        return status;
    }
  };

  return dot ? (
    <Tooltip title={getStatusText(status)}>
      <span>
        <Badge color={getStatusColor(status) === 'default' ? 'gray' : getStatusColor(status)} />
      </span>
    </Tooltip>
  ) : (
    <Tag color={getStatusColor(status)} style={style}>
      {getStatusText(status)}
    </Tag>
  );
};

export default DocumentStatusTag;
